
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/PartnerWithUs/apply",
      function () {
        return require("private-next-pages/PartnerWithUs/apply.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/PartnerWithUs/apply"])
      });
    }
  